<a class="block" routerLink="dashboard">
    <img class="block min-w-[7rem] max-w-[7rem] sm:min-w-[10rem] sm:max-w-[10rem] w-21" [src]="logo" alt="Logo" />
</a>
